const NotificationListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'url',
    width: 250
  },
  {
    title: 'Contact Group',
    slot: 'contact_group',
    sorter: (a, b) => a.contact_group.description.localeCompare(b.contact_group.description),
    width: 250
  },
  {
    title: 'Notification Type',
    dataIndex: 'notification_type_name',
    slot: 'notification_type_name',
    width: 250
  },
  {
    title: '',
    dataIndex: '',
    slot: 'operation',
    width: 50
  }
];
export { NotificationListColumn };
